export const environment = {
  production: false,
  apiUrl: 'https://sakooproyect-development.up.railway.app'
};
